import { Component, OnInit } from '@angular/core';
import { CatalogService } from '../../catalog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { Driver } from '../../models/drivers';
import { endpoints } from '../../../shared/apis/endpoints';
import { GenericList } from '../../../shared/commons/generic.responses';
import { States } from '../../../shared/static/usa-states';
import { Router } from '@angular/router';
declare var $: any;

export class DriverCatalogReq {
  DriverId: number;
  DriverName: string;
  IsActive: boolean;
  StateID: string;
  CityName: string;
  page: number;
  pageSize: number;

  constructor() {
    this.IsActive = true;
    this.StateID = '*';
    this.page = 1;
    this.pageSize = 50
  }

}

@Component({
  selector: 'app-drivers',
  templateUrl: './drivers.component.html',
  styleUrl: './drivers.component.scss'
})
export class DriversComponent implements OnInit {

  isLoading: boolean = false;
  currentPage: number = 1;
  driverCatalogReq = new DriverCatalogReq();
  drivers: Driver[] = [];
  selectedIdx: number;
  USAStates: GenericList[] = States;

  constructor(
    private _catalogService: CatalogService,
    private _toast: ToastService,
    private _router: Router
  ) { 
    this._toast.toastId = this.constructor.name;
  }

  ngOnInit(): void {
    this.ListDrivers();
    this.USAStates.push({ id: "*", descr: "-- All States --" });
  }

  ToggleLoading = () => this.isLoading = !this.isLoading;


  ListDrivers() {
    this.ToggleLoading();

    this._catalogService.GetAllDrivers(this.driverCatalogReq).subscribe({
      next: (res) => {

        this.drivers = res.body.map(obj => ({ ...obj, readOnly: true }));;
        console.log(this.drivers)
        
      },
      error: (err) => { console.log(err) },
      complete: () => { this.ToggleLoading(); }
    });
  }

  AppendToDriverList() {
    this.ToggleLoading();
    this.driverCatalogReq.page = this.currentPage;

    this._catalogService.GetAllDrivers(this.driverCatalogReq).subscribe({
      next: (res) => this.drivers = [...this.drivers, ...res.body.map(obj => ({ ...obj, readOnly: true }))],
      error: (err) => console.log(err),
      complete: () => this.ToggleLoading()
    });
  }

  OnScrollCustomerList() {
    this.currentPage++;
    this.AppendToDriverList();
  }

  InitDriver() {
    var newConsignee = new Driver();
    this.drivers.unshift(newConsignee);
  }

  SetEditMode(idx: number) {
    this.drivers[idx].readOnly = false;
  }

  OpenRemoveDriverModal(idx: number) {
    this.selectedIdx = idx;

    if (this.drivers[this.selectedIdx].DriverID == null) {
      this.drivers.splice(this.selectedIdx, 1);
      return;
    }

    $('#deleteDriver').modal('show');
  }

  RemoveDriver() {
    this._catalogService.DeleteCatalog(this.drivers[this.selectedIdx].DriverID, endpoints.DELETE_DRIVER).subscribe({
      next:() => {
        this._toast.ShowToast('success')
        this.drivers.splice(this.selectedIdx, 1);
        $('#deleteDriver').modal('hide');
      },
      error:() => {
        this._toast.ShowToast('error', "Can't delete this driver!")
      }
    })
  }

  OpenSetDriverStatusModal(idx: number) {
    this.selectedIdx = idx;
    $('#setDriverStatus').modal('show');
  }

  CloseAndRevertStatus() {
    this.drivers[this.selectedIdx].Active = !this.drivers[this.selectedIdx].Active;
    $('#setDriverStatus').modal('hide');
  }

  SetStatus() {
    this._catalogService.PatchCatalog(this.drivers[this.selectedIdx], endpoints.PATCH_DRIVER).subscribe({
      next: () => {
        this._toast.ShowToast('success')
        $('#setDriverStatus').modal('hide');
        this.drivers.splice(this.selectedIdx, 1);
      },
      error: () => this._toast.ShowToast('error')
    });
  }

  ClearSearchInput(value: string) {
    if (value == '') {
      this.ListDrivers();
    }
  }

  PatchDriver(s: Driver, idx: number) {
    this._catalogService.PatchCatalog(s, endpoints.PATCH_DRIVER).subscribe({
      next: (res) => {
        this._toast.ShowToast('success')
        $('#setDriverStatus').modal('hide');
        if (s.DriverID == null || s.DriverID == undefined)
          this.drivers[idx].DriverID = res.body;
      },
      error: () => this._toast.ShowToast('error'),
      complete: () => this.drivers[idx].readOnly = true
    });
  }

  SetCityId(idx: number, city: string) {
    this.drivers[idx].CityID = +city.split('. ')[0];
    this.drivers[idx].city = city.split('. ')[1];
  }

  SetStateId(idx: number, state: string) {
    this.drivers[idx].stateID = state.split('. ')[0];
    this.drivers[idx].state = state.split('. ')[1];
  }

  NavigateToDriverDetail(driverId: number) {

    if (localStorage.getItem('driver_id'))
      localStorage.removeItem('driver_id')
    
    localStorage.setItem('driver_id', driverId.toString());
    
    this._router.navigateByUrl('/catalogs/driver-details');
  }

}
